"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

function AddAccount(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#788590' : _ref$color,
      props = (0, _objectWithoutProperties2.default)(_ref, ["color"]);
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.153 20.5c.35.553.77 1.058 1.248 1.502L10.154 22v-1.5zM18.223 2C19.202 2 20 2.78 20 3.74v6.125a7.45 7.45 0 00-2.461-.794v-.196h-2.462v.26a7.446 7.446 0 00-1.847.613v-.873h-2.46v2.5h.253A7.474 7.474 0 009 16.5c0 .32.02.634.059.942a.837.837 0 00-.126.443v3.68a.44.44 0 01-.444.435H5.778C4.798 22 4 21.22 4 20.26V3.74C4 2.78 4.797 2 5.778 2h12.444zm-1.848 8.75a5.625 5.625 0 110 11.25 5.625 5.625 0 010-11.25zm.625 2.5h-1.25v2.499l-2.5.001V17l2.5-.001V19.5H17V17h2.5v-1.25H17v-2.5zm-8.077 0H6.462v2.5h2.461v-2.5zm0-4.375H6.462v2.5h2.461v-2.5zM17.538 4.5h-2.461V7h2.461V4.5zm-4.307 0h-2.462V7h2.462V4.5zm-4.308 0H6.462V7h2.461V4.5z",
    fill: color,
    fillRule: "evenodd"
  }));
}

var _default = AddAccount;
exports.default = _default;